import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/hooks/useAuth";

export function usePlans(enabled = true) {
  const qc = useQueryClient();
  const { user } = useAuth();
  const { data: plans = [] } = useQuery({ queryKey: ["plans"], queryFn: api.plans, enabled: enabled && !!user, refetchInterval: 30000 });
  const me = user?.user_id;

  const run = async (fn, msg) => {
    try {
      await fn();
      if (msg) toast.success(msg);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Something went wrong");
    }
    await qc.invalidateQueries({ queryKey: ["plans"] });
  };

  const statusOf = (p) => p.members.find((m) => m.user_id === me)?.status;

  return {
    me,
    plans,
    invites: plans.filter((p) => statusOf(p) === "pending"),
    planFor: (country) => plans.find((p) => p.country === country && statusOf(p) === "accepted"),
    invite: (country, friend) => run(() => api.invite(country, friend.friend_id), `Invited ${friend.name.split(" ")[0]} to ${country}`),
    respond: (p, accept) => run(async () => {
      await api.respondPlan(p.id, accept);
      if (accept) qc.invalidateQueries({ queryKey: ["state"] });
    }, accept ? `Trip to ${p.country} added to your list` : "Invite declined"),
    patch: (p, b) => run(() => api.patchPlan(p.id, b)),
    addNote: (p, text) => run(() => api.addPlanNote(p.id, text)),
    delNote: (p, noteId) => run(() => api.delPlanNote(p.id, noteId)),
    leave: (p) => run(() => api.leavePlan(p.id), `Left the ${p.country} trip`),
  };
}
